import { Dialog } from '@infotech-soe/erp-ui-kit';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AboutPreferencesPaneContainer from './AboutPreferencesPaneContainer';

const messages = defineMessages({
  title: {
    id: 'core.preferencesDialog.about',
    defaultMessage: 'About program',
  },
});

interface Props {
  open: boolean;
  onClose: () => void;
}

const AboutPreferencesDialog: React.FC<Props> = ({ open, onClose }) => {
  const intl = useIntl();

  return (
    <Dialog
      title={intl.formatMessage(messages.title)}
      open={open}
      onClose={onClose}
      width={640}
      height="auto"
    >
      <AboutPreferencesPaneContainer />
    </Dialog>
  );
};

export default AboutPreferencesDialog;
